exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23R5 {\n    position: relative;\n    padding: 0 1rem;\n    margin-bottom: 2rem;\n}\n\n.fXWu {\n    position: relative;\n}\n\n@media (min-width: 48rem) {\n    ._23R5 {\n        padding: 0;\n        max-width: 20rem;\n        margin: 0 auto;\n        margin-bottom: 2rem;\n    }\n}\n\n._3qIC {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n@media (min-width: 768px) {\n    ._3qIC {\n        margin-bottom: 1rem;\n    }\n}\n\n._2q5R {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 1rem;\n}\n\n@media screen and (min-width: 48rem) {\n    ._23R5 {\n        max-width: 42rem;\n    }\n}\n\n@media screen and (min-width: 80rem) {\n    ._23R5 {\n        max-width: 64rem;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"container": "_23R5",
	"body": "fXWu",
	"header": "_3qIC",
	"subHeader": "_2q5R"
};